import { NativeFeatureIdentifier, FindNativeFeature } from '@standardnotes/features';
import { FeatureStatus } from '@standardnotes/services';
import { convertTimestampToMilliseconds } from '@standardnotes/utils';
export class GetFeatureStatusUseCase {
    constructor(items) {
        this.items = items;
    }
    execute(dto) {
        if (this.isFreeFeature(dto.featureId)) {
            return FeatureStatus.Entitled;
        }
        const nativeFeature = this.findNativeFeature(dto.featureId);
        if (!nativeFeature) {
            return this.getThirdPartyFeatureStatus(dto.featureId);
        }
        if (nativeFeature.deprecated) {
            return this.getDeprecatedNativeFeatureStatus({
                nativeFeature,
                hasPaidAnyPartyOnlineOrOfflineSubscription: dto.hasPaidAnyPartyOnlineOrOfflineSubscription,
            });
        }
        return this.getNativeFeatureFeatureStatus({
            nativeFeature,
            firstPartyOnlineSubscription: dto.firstPartyOnlineSubscription,
            firstPartyRoles: dto.firstPartyRoles,
            inContextOfItem: dto.inContextOfItem,
        });
    }
    findNativeFeature(featureId) {
        return FindNativeFeature(featureId.value);
    }
    getDeprecatedNativeFeatureStatus(dto) {
        if (dto.hasPaidAnyPartyOnlineOrOfflineSubscription) {
            return FeatureStatus.Entitled;
        }
        else {
            return FeatureStatus.NoUserSubscription;
        }
    }
    getNativeFeatureFeatureStatus(dto) {
        if (dto.inContextOfItem) {
            const isSharedVaultItem = dto.inContextOfItem.shared_vault_uuid !== undefined;
            if (isSharedVaultItem) {
                return FeatureStatus.Entitled;
            }
        }
        if (!dto.firstPartyOnlineSubscription && !dto.firstPartyRoles) {
            return FeatureStatus.NoUserSubscription;
        }
        const roles = !dto.firstPartyRoles
            ? undefined
            : 'online' in dto.firstPartyRoles
                ? dto.firstPartyRoles.online
                : dto.firstPartyRoles.offline;
        if (dto.nativeFeature.availableInRoles && roles) {
            const hasRole = roles.some((role) => {
                var _a;
                return (_a = dto.nativeFeature.availableInRoles) === null || _a === void 0 ? void 0 : _a.includes(role);
            });
            if (!hasRole) {
                return FeatureStatus.NotInCurrentPlan;
            }
        }
        if (dto.firstPartyOnlineSubscription) {
            const isSubscriptionExpired = new Date(convertTimestampToMilliseconds(dto.firstPartyOnlineSubscription.endsAt)) < new Date();
            if (isSubscriptionExpired) {
                return FeatureStatus.InCurrentPlanButExpired;
            }
        }
        return FeatureStatus.Entitled;
    }
    getThirdPartyFeatureStatus(uuid) {
        const component = this.items.getDisplayableComponents().find((candidate) => candidate.uuid === uuid.value);
        if (!component) {
            return FeatureStatus.NoUserSubscription;
        }
        if (component.isExpired) {
            return FeatureStatus.InCurrentPlanButExpired;
        }
        return FeatureStatus.Entitled;
    }
    isFreeFeature(featureId) {
        return [
            NativeFeatureIdentifier.TYPES.DarkTheme,
            NativeFeatureIdentifier.TYPES.PlainEditor,
            NativeFeatureIdentifier.TYPES.ProtonTheme,
        ].includes(featureId.value);
    }
}
